var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    fill: "#cae0eb"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 9v15H9v2h15v15h2V26h15v-2H26V9z"
  })));
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0iI2NhZTBlYiI+PHBhdGggZD0iTSAyNCA5IEwgMjQgMjQgTCA5IDI0IEwgOSAyNiBMIDI0IDI2IEwgMjQgNDEgTCAyNiA0MSBMIDI2IDI2IEwgNDEgMjYgTCA0MSAyNCBMIDI2IDI0IEwgMjYgOSBaIiBmaWxsPSIjY2FlMGViIi8+PC9zdmc+Cg==";
export { SvgPlus as ReactComponent };